export enum ZoneType {
  Occupation = 'Occupation',
  HumanTracking = 'HumanTracking',
}
